import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import Helmet from 'react-helmet';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { MandatoryAdditionalStyle } from '../../components.utils';

interface FacebookComponentDataProps {
    html: string;
    dataId?: string;
}

const createStyle = () => StyleSheet.create({
  style: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export const removeDataWidthFromHtml = (html: string) => html.replace(/data-width="\d+"/, 'data-width=""');

type FacebookComponentProps = FacebookComponentDataProps & MandatoryAdditionalStyle;
const facebookVersion = 'v3.3';
export const FacebookComponent: React.FunctionComponent<FacebookComponentProps> = props => {
  const { html, additionalStyle, dataId } = props;

  const facebookStyle = createStyle();

  React.useEffect(() => {
    // @ts-ignore TS2339
    if (typeof window.FB !== 'undefined') {
      // @ts-ignore TS2339
      // eslint-disable-next-line no-undef
      FB.init({
        xfbml: true,
        version: facebookVersion,
      });
    }
  }, []);

  const htmlWithFluidWidth = removeDataWidthFromHtml(html);
  return (
    <ErrorBoundary>
      <Helmet>
        <script async defer src={`https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=${facebookVersion}`} />
      </Helmet>
      {/* eslint-disable-next-line react/no-danger */}
      <figure data-id={dataId} dangerouslySetInnerHTML={{ __html: htmlWithFluidWidth }} className={css(facebookStyle.style, additionalStyle.style)} />
    </ErrorBoundary>
  );
};

export const Facebook = (props: FacebookComponentProps) => <ErrorBoundary><FacebookComponent {...props} /></ErrorBoundary>;
